import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Preloader from '../preloader/Preloader'

//services
import { getOperatorSingle, createOperators, updateOperators } from 'src/services'

//components
import { BreadCrumb, Card } from 'src/components'

const CreateOrUpdate = () => {
  const history = useHistory()
  const { id } = useParams()
  const isUpdating = id !== undefined
  const [loading, setLoading] = useState(isUpdating)
  const [inputList, setInputList] = useState({
    fname: '',
    lname: '',
    phone: '',
    error_list: [],
  })

  useEffect(() => {
    if (isUpdating) {
      getOperatorSingle(id)
        .then((res) => {
          if (res.data.status === 200) {
            setInputList(res.data.operator)
          } else {
            history.push('/operators')
          }
          setLoading(false)
        })
        .catch(() => {
          history.push('/operators')
          setLoading(false)
        })
    }
  }, [id, history, isUpdating])

  const handleInput = (e) => {
    e.persist()
    setInputList({ ...inputList, [e.target.name]: e.target.value })
  }

  const submitForm = (e) => {
    e.preventDefault()
    const data = inputList

    const submitAction = isUpdating ? () => updateOperators(id, data) : () => createOperators(data)

    submitAction()
      .then((res) => {
        if (res.data.status === 200) {
          swal('Success', res.data.message, 'success')
          history.push('/operators')
        } else if (res.data.status === 400 || res.data.status === 422) {
          setInputList({ ...inputList, error_list: res.data.errors || {} })
        }
      })
      .catch((error) => {
        swal('Error', 'An error occurred', 'error')
      })
  }

  if (loading) {
    return <Preloader />
  }

  const title = 'Operators'
  const isanupdate = isUpdating ? 'Update' : 'Add'

  const breadcrumb = [
    {
      title: title,
      name: 'Add' + title,
      subtitle: isanupdate,
      subtitleroute: '/operators',
    },
  ]

  const cardValues = [
    {
      title: title,
      addorupdate: isanupdate,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <div className="content">
        <div className="card card-primary">
          <Card data={cardValues}>
            <form onSubmit={submitForm}>
              <div className="row">
                {/* First Name */}
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="pb-2">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="fname"
                      onChange={handleInput}
                      value={inputList.fname}
                      placeholder="First Name"
                    />
                    <span className="text-danger">{inputList?.error_list?.fname}</span>
                  </div>
                </div>
                {/* Last Name */}
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="pb-2">
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="lname"
                      onChange={handleInput}
                      value={inputList.lname}
                      placeholder="Last Name"
                    />
                    <span className="text-danger">{inputList?.error_list?.lname}</span>
                  </div>
                </div>
                {/* Phone Number */}
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="pb-2">
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="phone"
                      onChange={handleInput}
                      value={inputList.phone}
                      placeholder="Phone Number"
                    />
                    <span className="text-danger">{inputList?.error_list?.phone}</span>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                {isUpdating ? 'Update' : 'Save'}
              </button>
            </form>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default CreateOrUpdate
